import React from 'react';

export default function PlanBenefit({ benefits }) {
	return (
		<div>
			<div>
				<div className="subscription-border my-3"></div>
				<div className="fs-3 fw-semibold py-2">Why Upgrade?</div>
				<div className="d-flex justify-content-between align-items-center py-4 gap-4">
					{benefits.map((item, index) => (
						<div className="d-flex justify-content-start gap-2 px-2">
							<div className="d-flex justify-content-start align-items-center">
								<img
									src={item.icon}
									alt="icon"
								/>
								<div className="px-4">
									<div className="d-flex gap-4 align-items-center">
										<div className="fs-4 font-medium">{item.title}</div>
									</div>
									<div className="fs-5 font-small">{item.description}</div>
								</div>
							</div>
							{benefits.length !== index + 1 && <div className="subscription-divider"></div>}
						</div>
					))}
				</div>
				<div className="subscription-border my-3"></div>
			</div>
		</div>
	);
}
